import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import { configure } from 'axios-hooks'
import React from 'react'
import ReactDOM from 'react-dom'

import config from 'config'
import { initFirebase } from 'libs/firebase'

import App from './App'
import reportWebVitals from './reportWebVitals'

import '!style-loader!css-loader!sass-loader!./styles/styles.scss'

config()
initFirebase()

Sentry.init({
  enabled: window._env_.REACT_APP_SENTRY_ENABLE === 'true',
  dsn: window._env_.REACT_APP_SENTRY_DSN,
  environment: window._env_.NODE_ENV ?? 'production',
  release: window._env_.REACT_APP_SENTRY_RELEASE,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: Number(window._env_.REACT_APP_TRACES_SAMPLE_RATE) ?? 0,
})

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

reportWebVitals()
configure({ cache: false })
